<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" scrollable persistent :overlay="false" max-width="800px" transition="dialog-transition">
      <v-card width="800px">
        <v-toolbar color="blue white--text darken-3" flat>
          <v-toolbar-title>Datos de nota de credito debito.</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text class="pt-0">
          <v-progress-linear indeterminate v-if="loading" />
          <p class="text-center red--text">{{ msg }}</p>
        </v-card-text>
        <v-divider class="my-0"></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="ma-2" color="success" tile @click="save()">
            <v-icon class="mx-1">mdi-content-save</v-icon> Guardar
          </v-btn>
          <v-btn color="blue darken-1" outlined tile @click="dialog = !dialog">
            Cancelar <v-icon> mdi-close</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
  export default {
    data() {
      return {
        dialog: false,
        loading: false,
        msg: '',
      };
    },
    components: {},
    methods: {
      async showThisView() {
        this.dialog = true;
      },
      save() {},
    },
    mounted() {},
  };
</script>

<style></style>
